export function degToRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
